export default {
    navigationBarTitleText: intl.get('cooperate.settled'),
    navigationBarBackgroundColor: "#DF773C",
};
